import {debounce} from 'lodash';
import {useCallback, useState} from 'react';

import {useElasticQuery} from '@/hooks/useElasticQuery';

import {ListingSearchResultT, UseListingSearchT} from '../types/competitive-analysis.types';

export function useListingSearch(): UseListingSearchT {
  const [searchTerm, setSearchTerm] = useState('');

  const debouncedSearch = useCallback(debounce(setSearchTerm, 500), []);

  const {data, isLoading, error} = useElasticQuery({
    table: 'tnc.weedmaps.listings',
    searchRequest: {
      index: 'tnc.weedmaps.listings',
      query: {
        bool: {
          must: [
            {
              multi_match: {
                query: searchTerm,
                fields: ['name^2', 'address'],
                type: 'phrase_prefix',
              },
            },
          ],
        },
      },
      _source: ['id', 'name', 'menu_id', 'latitude', 'longitude'],
      collapse: {
        field: 'menu_id',
      },
    },
    enabled: searchTerm.length >= 2,
  });

  const results: ListingSearchResultT[] =
    data?.data?.map((hit: any) => ({
      id: hit._id,
      name: hit._source.name,
      menu_id: hit._source.menu_id,
      latitude: hit._source.latitude,
      longitude: hit._source.longitude,
    })) || [];

  return {
    searchTerm,
    setSearchTerm: debouncedSearch,
    results,
    isLoading,
    error,
  };
}
